import { render, staticRenderFns } from "./DisabilityFormModal.vue?vue&type=template&id=fa5c9e58&scoped=true&"
import script from "./DisabilityFormModal.vue?vue&type=script&lang=js&"
export * from "./DisabilityFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5c9e58",
  null
  
)

export default component.exports